import { ClerkProvider } from "@clerk/clerk-react";
import { enUS, esMX } from "@clerk/localizations";
import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

type LazyClerkProviderProps = {
  children: ReactNode;
};

export function LazyClerkProvider({ children }: LazyClerkProviderProps) {
  const { i18n } = useTranslation();
  const clerkLocalization = i18n.resolvedLanguage === "en" ? enUS : esMX;

  if (!publishableKey) {
    throw new Error("Missing VITE_CLERK_PUBLISHABLE_KEY. Add it to your .env.local file.");
  }

  return (
    <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/" localization={clerkLocalization}>
      {children}
    </ClerkProvider>
  );
}
